interface ComponentProps {
  children?: any;
}
const CardViewWrapper: React.FC<ComponentProps> = ({ children }) => {
  return <div className="card-wrapper"> {children} </div>;
};

export default CardViewWrapper;
